module.exports = __webpack_public_path__ + "img/lg_ring_y_skip_0_null.aaff33ab.png";